import { HeroParticles } from "./_partials/HeroParticles";
import { HeroCpiVisual } from "./_partials/HeroCpiVisual";
import HeroCopy from "./_partials/HeroCopy";
import HeroActions from "./_partials/HeroActions";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden border-b border-border min-h-[100svh] flex items-center pt-20 md:pt-20 pb-12 md:pb-14"
    >
      {/* Blueprint grid bg — HUD signature, toned down */}
      <div className="absolute inset-0 iw-grid-bg opacity-40" aria-hidden="true" />
      <HeroParticles />

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
        {/* Left — text */}
        <div className="lg:col-span-7 z-10 max-w-3xl">
          <HeroCopy />
          <HeroActions />
        </div>

        {/* Right — visual */}
        <HeroCpiVisual />
      </div>
    </section>
  );
}
